import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useBrowserMode() {
  const route = useRoute()
  const isBrowser = computed(() => route.query.browser === 'true')
  return { isBrowser }
}
